import { Box, Button, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { darkTheme, lightTheme } from "../layouts/theme/index";
import createCache from "@emotion/cache";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
// import SingInForum from "./SingInForum/SingInForum"
import {
  findSubtitlesApi,
  findSubtitlesWithIdApi,
} from "../services/subtitlesApi";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../components/pages/utils/utilsFunctions";
import Paper from "@mui/material/Paper";
import { useParams } from "react-router-dom";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import OneSub from "./OneSub";
import SearchSub from "./SearchSub";
import SubSearchResult from "./SubSearchResult";
import { ToastContainer } from "react-toastify";
import FormControlLabel from "@mui/material/FormControlLabel";
import Login from "../components/user-login/Login";
import LoginAlert from "./LoginAlert";
import ReactPlayer from "react-player";
import Player from "./Player";

const cacheRTL = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          "#fff"
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme.palette.mode === "dark" ? "#003892" : "#001e3c",
    width: 32,
    height: 32,
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        "#fff"
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
    borderRadius: 20 / 2,
  },
}));

const Sub = () => {
  const [lighteMode, setLightMode] = useState(false);
  const { id } = useParams();

  const [signInBox, setSignInBox] = useState(false);
  const [userTypes, setUserTypes] = useState([]);
  const [showLoginForm, setShowLoginForm] = useState(false);
  const [searchClick, setSearchClick] = useState(false);
  const [subtitlesList, setSubtitlesList] = useState(false);
  const [subtitlesListPaginate, setSubtitlesListPaginate] = useState({
    totalDocs: 0,
    totalPages: 0,
    page: 0,
  });
  const [searchById, setSearchById] = useState(false);

  const searchSubtitle = async (type, data, paginate) => {
    try {
      let response;
      setSearchClick(true);
      setSubtitlesList(false);
      if (type == "id") {
        if (data["subtitlesUploadId"].length > 0) {
          response = await findSubtitlesWithIdApi(data, paginate);
          setSubtitlesListPaginate({ totalDocs: 0, totalPages: 0, page: 0 });
        } else customToastify("warning", "لطفا آی دی زیرنویس را وارد کنید");
      } else {
        response = await findSubtitlesApi(data, paginate);
      }
      const resData = checkResponseData(response);
      if (resData["success"]) {
        if (type == "id") {
          if (resData["data"]["data"][0]["subtitlesUploadId"])
            setSubtitlesList(resData["data"]["data"]);
          else {
            setSubtitlesList([]);
            customToastify("error", "زیرنویس با این آی دی پیدا نشد");
          }
        } else setSubtitlesList(resData["data"]["docs"]);
        let { totalDocs, totalPages, page } = resData["data"];
        setSubtitlesListPaginate({ totalDocs, totalPages, page });
        if (totalDocs == 0)
          customToastify("error", "زیرنویسی با این مشخصات پیدا نشد");
        // setSearchClick(false)
        // toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
      } else {
        // toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"];
      console.log("errData,", errMsg);
      // toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      // console.error(error);
      customToastify("error", errMsg);
      setSearchClick(false);
    }
  };

  const controlThemeMode = () => {
    setLightMode(!lighteMode);
    localStorage.setItem("themeMode", !lighteMode);
  };

  const handleShowLoginForm = (value) => {
    setShowLoginForm(value);
  };

  function CheckUserSignIn() {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      if (token) {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          window
            .atob(base64)
            .split("")
            .map(function (c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );
        const typeUser = JSON.parse(jsonPayload)["type"];
        setUserTypes(typeUser);
      } else {
        // در نسخه نهایی user باید پاک شود
        setUserTypes("");
        setSignInBox(true);
      }
    } catch {
      // در نسخه نهایی user باید پاک شود
      setUserTypes([""]);
    }
  }

  const handleUserType = (types) => {
    setUserTypes(types);
  };

  const handleCloseSignInBox = () => {
    const token = JSON.parse(localStorage.getItem("token"));
    if (!userTypes && token) CheckUserSignIn();
    if (token) setSignInBox(false);
  };

  function CheckInitialMode() {
    try {
      const themeMode = JSON.parse(localStorage.getItem("themeMode"));
      if (themeMode) {
        setLightMode(themeMode);
      } else {
        console.log("Theme Mode is Dark");
      }
    } catch {
      console.log("Problem in theme Mode");
    }
  }

  useEffect(() => {
    CheckInitialMode();
    CheckUserSignIn();
  }, []);

  return (
    <CacheProvider value={cacheRTL}>
      <ThemeProvider theme={lighteMode ? lightTheme : darkTheme}>
        <HelmetProvider>
          <Helmet>
            <title>UMLANG - یادگیری زبان با استفاده از فیلم (اوملنگ)</title>
          </Helmet>
          {userTypes.length == 0 && showLoginForm ? (
            <>
              <Login
                signInBox={signInBox}
                handleCloseSignInBox={handleCloseSignInBox}
                handleUserType={handleUserType}
              />
              <LoginAlert />
            </>
          ) : null}
          <Box
            sx={{
              display: "flex",
              // justifyContent: 'center',
              pt: 1,
              alignItems: "center",
              flexDirection: "column",
              minHeight: "100vh",
              backgroundColor: lighteMode ? "#42a5f5" : "#3F4652",
            }}
          >
            <Player />
            <MaterialUISwitch
              onClick={controlThemeMode}
              sx={{ m: 1, position: "fixed", top: "1px", left: "1px" }}
              checked={!lighteMode}
            />
            <Box sx={{ textAlign: "center", top: "1px" }}>
              <a target="_blank" href="https://umlang.com">
                <Button sx={{ mt: 1 }} size="small" variant="contained">
                  صفحه اصلی
                </Button>
              </a>

              <hr />
              {/* <Checkbox  size="small" label="نام فیلم یا سریال" /> */}
              {/* <Checkbox checked={searchById} size="small" /> */}
              <FormControlLabel
                onClick={() => {
                  setSearchById(!searchById);
                  setSubtitlesListPaginate({
                    totalDocs: 0,
                    totalPages: 0,
                    page: 0,
                  });
                }}
                control={<Switch checked={searchById} />}
                label="جستجو با آی دی"
              />
            </Box>
            <SearchSub
              userTypes={userTypes}
              handleShowLoginForm={handleShowLoginForm}
              subtitlesListPaginate={subtitlesListPaginate}
              searchById={searchById}
              searchSubtitle={searchSubtitle}
            />
            {searchClick ? (
              <SubSearchResult subtitlesList={subtitlesList} />
            ) : (
              <Routes>
                <Route
                  path="/:id"
                  element={
                    <OneSub
                      userTypes={userTypes}
                      handleShowLoginForm={handleShowLoginForm}
                    />
                  }
                />
              </Routes>
            )}
          </Box>
          <ToastContainer
            position="bottom-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={true}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        </HelmetProvider>
      </ThemeProvider>
    </CacheProvider>
  );
};

export default Sub;
